export default __webpack_public_path__ + "static/media/bunny.59e55a11.png";